import type { JSX } from 'react'
import type { ChannelProviderName } from '../../../pages/admin/channels-types.js'
import { PROVIDER_ICONS, PROVIDER_LABELS } from '../../../pages/admin/channel-provider-meta.js'

export type TabProvider = ChannelProviderName | 'twilio'

export interface ProviderTabsProps {
  providers: ChannelProviderName[]
  activeProvider: TabProvider
  onSelect: (provider: TabProvider) => void
}

/** Provider tab bar for the Channels admin page (OAuth channel providers + Twilio SMS). */
export default function ProviderTabs(props: ProviderTabsProps): JSX.Element {
  const allTabs: TabProvider[] = [...props.providers, 'twilio']

  return (
    <div className="inline-flex flex-wrap items-center gap-2 border border-gray-200 rounded-xl px-2 min-h-14 bg-white mb-6">
      {allTabs.map((provider) => (
        <button
          key={provider}
          onClick={() => props.onSelect(provider)}
          className={`h-14 px-4 flex items-center gap-2 font-semibold text-sm border-b-[3px] transition-colors ${
            props.activeProvider === provider
              ? 'border-blue-600 text-blue-600'
              : 'border-transparent text-gray-700 hover:text-gray-900 hover:bg-gray-50'
          }`}
        >
          {provider === 'twilio' ? <i className="pi pi-comment text-indigo-500 text-lg" /> : PROVIDER_ICONS[provider]}
          {provider === 'twilio' ? 'Twilio SMS' : PROVIDER_LABELS[provider]}
        </button>
      ))}
    </div>
  )
}
